import React from "react";
import { Box, Stack, Typography, useTheme } from "@mui/material";
import { alpha } from "@mui/material/styles";
import PersonRounded from "@mui/icons-material/PersonRounded";
import { FONTS } from "../../../../constants/styles";

const BookingForClientChip = () => {
    const theme = useTheme();
    const primary = theme.palette.primary.main;

    const clientName =
        typeof window !== "undefined"
            ? sessionStorage.getItem("booking_for_client_name")
            : null;

    if (!clientName) return null;

    return (
        <Box sx={{ px: 2, pb: 1 }}>
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{
                    bgcolor: alpha(primary, 0.08),
                    border: `1px solid ${alpha(primary, 0.18)}`,
                    borderRadius: "999px",
                    px: 1.5,
                    py: 0.5,
                    width: "fit-content",
                    maxWidth: "100%",
                }}
            >
                <PersonRounded sx={{ fontSize: 16, color: primary }} />
                <Typography
                    fontFamily={FONTS.display}
                    fontWeight={600}
                    fontSize="12px"
                    color={primary}
                    noWrap
                    sx={{ minWidth: 0, overflow: "hidden", textOverflow: "ellipsis" }}
                >
                    For: <span className="no-translation">{clientName}</span>
                </Typography>
            </Stack>
        </Box>
    );
};

export default BookingForClientChip;
